import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  namespaced: true,
  state: {
    evaluateCreditClass: {}
  },
  getters: {
    evaluateCreditClass: state => state.evaluateCreditClass
  },
  mutations: {
    SET_EVALUATE_CREDIT_CLASS: (state, data) => { state.evaluateCreditClass = data }
  },
  actions: {
    async getStudentEvaluateCreditClass({ commit }, params) {
      try {
        const response = await axios.get('studentEvaluateCreditClasses', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_EVALUATE_CREDIT_CLASS', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async createStudentEvaluateCreditClass({ commit }, params) {
      try {
        const response = await axios.post('studentEvaluateCreditClasses', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async updateStudentEvaluateCreditClass({ commit }, params) {
      try {
        const response = await axios.put('studentEvaluateCreditClasses', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
